/** @jsx jsx */
import React from 'react'
import { jsx } from 'theme-ui'
import { useEntity, useComponent } from './helpers/selectors'
import { cf2imgix } from './helpers/imgix-image'
import SponsoredByTag from './tag'
import { usePalette } from '../utils/palette'

const SponsoredBy = ({ displayText, providerLogo, ...props }) => {
  const [, C] = useComponent({ tag: 'container' })
  const { textColor } = usePalette()

  const logoImg = useEntity(providerLogo)
  const providerLogoUrl = cf2imgix(logoImg?.file?.url)

  const styles = textColor ? { span: { color: textColor } } : {}

  return (
    <C>
      <SponsoredByTag
        sx={styles}
        providerLogoSrc={providerLogoUrl}
        providerText={displayText}
        {...props}
      />
    </C>
  )
}

export default SponsoredBy
